export const company = {
  name: "AMVI Technologies",
  legalName: "AMVI Technologies LLC",
  tagline: "Engineering the Future with AI, Data, Cloud & Talent",
  positioning: "AI + Data + Cloud + Engineering + Talent",
  email: "hr@amvitechnologies.com",
  phone: "514-980-7696",
  phoneHref: "tel:+15149807696",
  address: {
    line1: "501 Silverside Rd, Ste 105 #5491",
    city: "Wilmington",
    state: "DE",
    zip: "19809",
    country: "United States",
  },
  linkedin: "https://www.linkedin.com/company/amvi-technologies-llc",
  market: "United States",
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Solutions", to: "/solutions" },
  { label: "Talent Solutions", to: "/talent-solutions" },
  { label: "Insights", to: "/insights" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const trustFeatures = [
  {
    icon: "BrainCircuit",
    title: "AI & Digital Transformation",
    description:
      "Generative AI, machine learning and intelligent automation that turn ambition into measurable outcomes.",
  },
  {
    icon: "Database",
    title: "Data & Analytics",
    description:
      "Modern data platforms, pipelines and analytics that make information a competitive advantage.",
  },
  {
    icon: "Cloud",
    title: "Cloud & Engineering",
    description:
      "Cloud-native architecture, DevOps and software engineering built for scale and resilience.",
  },
  {
    icon: "Building2",
    title: "Industry Expertise",
    description:
      "Deep sector knowledge that aligns technology and talent to your specific business context.",
  },
  {
    icon: "Users",
    title: "Specialized Talent",
    description:
      "Access to highly skilled technical and engineering professionals, exactly when you need them.",
  },
];

export const whyAmvi = [
  {
    icon: "Layers",
    title: "Technology Depth",
    description: "AI, data, cloud and engineering expertise under one partner.",
  },
  {
    icon: "Target",
    title: "Industry Understanding",
    description: "Technology and talent aligned to industry-specific needs.",
  },
  {
    icon: "UserCheck",
    title: "Specialized Talent",
    description: "Access to highly skilled technical professionals.",
  },
  {
    icon: "Shuffle",
    title: "Flexible Engagement",
    description: "Contract, direct hire, contract-to-hire and project models.",
  },
  {
    icon: "Zap",
    title: "Responsive Partnership",
    description: "Fast communication and client-focused delivery.",
  },
  {
    icon: "Handshake",
    title: "Long-Term Focus",
    description: "Build relationships rather than one-time transactions.",
  },
];

export const marqueeItems = [
  "Artificial Intelligence",
  "Generative AI",
  "Data Engineering",
  "Cloud & DevOps",
  "Software Engineering",
  "Semiconductor",
  "Digital Transformation",
  "IT Staffing",
  "Engineering Staffing",
  "Dedicated Teams",
];
